import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { writeText } from 'clipboard-polyfill'
import { useSelector } from 'react-redux'

import { Button, ButtonType } from '../../../../../../Styleguide/Button'
import { toastNotifyCopyTelephoneNumberSuccess } from '../toasts'
import { getParsedPhoneNumber, getTelephoneNumberWithCode } from '../utils'
import { botHostingMetadataSelector } from '../../../../../../../features/hostingVersions/selectors/botHostingMetadataSelector'

export const CopyTelephoneNumberButton: React.FC = () => {
  const telephoneNumber = useSelector(botHostingMetadataSelector)?.telephonyNumber
  const telephoneNumbers = useSelector(botHostingMetadataSelector)?.telephonyNumbers || []
  const allNumbers = _.uniq([...telephoneNumbers, telephoneNumber]).filter(n => !!n) as string[]

  if (allNumbers.length === 0) {
    return null
  }

  const buttons = allNumbers.map(number => {
    const telephoneNumberWithCode = getTelephoneNumberWithCode(number)
    const parsedTelephoneNumber = getParsedPhoneNumber(number)

    return { text: `${parsedTelephoneNumber}`, number: telephoneNumberWithCode }
  })

  return (
    <>
      {buttons.map(({ text, number }) => (
        <PhoneNumber>
          <Button
            text={text}
            buttonType={ButtonType.DEFAULT}
            onClick={async e => {
              e.preventDefault()
              await writeText(number)
              toastNotifyCopyTelephoneNumberSuccess()
            }}
          />
        </PhoneNumber>
      ))}
    </>
  )
}

const PhoneNumber = styled.div`
  margin: 5px;
  display: inline-block;
`
